<div class="change-password border-r-16 no-gutters" *transloco="let t">
  <div class="col">
    <div class="row no-gutters" *ngIf="passwordChanged">
      <div class="col">
        <div class="alert alert-success" role="alert">{{ t('user/changePasswordSuccess') }}</div>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col">
        <form (ngSubmit)="onSubmit()" #changePasswordForm="ngForm">
          <div class="form-group">
            <label for="oldPassword">{{ t('user/originalPassword') }}</label>
            <input
              name="oldPassword"
              [(ngModel)]="changePassword.oldPassword"
              type="password"
              class="form-control form-control-lg"
              [ngClass]="{ 'is-invalid': oldPasswordError !== null }"
              id="oldPassword"
              placeholder="{{ t('user/yourOriginalPassword') }}"
              required
            />
            <div class="invalid-feedback">
              {{ oldPasswordError }}
            </div>
          </div>
          <div class="form-group">
            <label for="newPassword1">{{ t('user/newPassword') }}</label>
            <input
              name="newPassword"
              [(ngModel)]="changePassword.newPassword"
              type="password"
              class="form-control form-control-lg"
              [ngClass]="{ 'is-invalid': newPasswordError !== null }"
              id="newPassword1"
              placeholder="{{ t('user/yourNewPassword') }}"
              required
            />
            <div class="invalid-feedback">
              {{ newPasswordError }}
            </div>
          </div>
          <div class="form-group">
            <label for="newPassword2">{{ t('user/newPasswordConfirmation') }}</label>
            <input
              name="newPasswordConfirm"
              [(ngModel)]="changePassword.newPasswordConfirm"
              type="password"
              class="form-control form-control-lg"
              [ngClass]="{ 'is-invalid': newPasswordConfirmError !== null }"
              id="newPassword2"
              placeholder="{{ t('user/newPasswordAgain') }}"
              required
            />
            <div class="invalid-feedback">
              {{ newPasswordConfirmError }}
            </div>
          </div>

          <hr />

          <div class="text-center">
            <button [routerLink]="links.homepage()" class="btn btn-lg btn-outline-primary me-4">
              {{ t('child/cancel') }}
            </button>
            <button type="submit" class="btn btn-lg btn-primary" [disabled]="!changePasswordForm.form.valid || disabledButton">
              {{ t('user/passwordChange') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
